import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Title from '~/src/feature/toyono/components/Title';
import ContactGrid from '../../ContactGrid';
import toyonoLogo from '../../../../images/features/toyono/toyono_logo.png';
import osakaSmartLogo from '../../../../images/features/toyono/osaka_smart_logo.png';
import cspfcLogo from '../../../../images/features/toyono/cspfc_logo.png';

const Container = styled.div<{ theme: Theme }>`
  margin: auto;
  width: 100%;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 1200px;
  }
`;

const LogoContainer = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
  text-align: center;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: ${({ theme }) => theme.spacing(9)}px;
    display: flex;
    flex-wrap: wrap;
  }
`;

const Img = styled.img<{ width?: number | string; theme: Theme }>`
  display: block;
  margin: ${({ theme }) => theme.spacing(0, 'auto', 2)};
  width: ${({ width }) => (width ? `${width}` : 'auto')};
  height: 100%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: ${({ theme }) => theme.spacing(0, 4)};
  }
`;

interface Props {}

const Partner: VFC<Props> = () => {
  const theme = useTheme();
  const isPc = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <Container theme={theme}>
      <Title text="PARTNER">連携パートナー</Title>
      <LogoContainer theme={theme}>
        <Img
          src={toyonoLogo}
          theme={theme}
          width={isPc ? '180px' : '35%'}
          alt="豊能町"
        />
        <Img
          src={osakaSmartLogo}
          theme={theme}
          width={isPc ? '180px' : '35%'}
          alt="OSAKA SMARTCITY PARTNERS FORUM"
        />
        <Img
          src={cspfcLogo}
          theme={theme}
          width={isPc ? '530px' : '80%'}
          alt="一般社団法人コンパクトスマートシティプラットフォーム"
        />
      </LogoContainer>
      <ContactGrid>
        他にも連携希望の市町村募集しております！人手不足等の困り事をキッカケに、一緒に関係人口を創出しましょう。ご希望の方はこちらのフォームからお気軽にお問い合わせください。
      </ContactGrid>
    </Container>
  );
};

export default Partner;
